<template>
	<b-modal
		ref="modal-view"
		size="xl"
		:title="
			_isNewModel
				? 'Nuevo mapeo'
				: 'Edición de mapeo'
		"
		scrollable
		hide-footer
		body-class="p-0">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-form class="container" @submit="onSubmit">
			<div class="row px-4 pt-2">
				<div class="col-lg-8">
					<b-form-group
						label="Nombre de mapeo*">
						<select :disabled="_isNewModel==false || !$hasPermission('mapping.edit')" class="form-control" v-model="model.name" @change="onChangeNameMapping">
							<option v-for="(value, key) in arrayMappingName" :key="key" :value="key">{{key}}</option>
						</select>
					</b-form-group>

					<b-form-group
						:disabled="!$hasPermission('mapping.edit')"
						label="Descripción (Opcional)">
						<b-form-textarea
							id="textarea-small"
							size="sm"
							v-model="model.description"
							placeholder="Small textarea"
						></b-form-textarea>
					</b-form-group>
				</div>
				<div class="col-lg-4 d-flex justify-content-end">
					<div class="w-75  d-flex flex-column  justify-content-end mb-2">
						<b-button :disabled="!$hasPermission('mapping.edit')" class="flex-grow-1 w-100 mb-2"  variant="primary" @click="addServiceTypesMapping()">Nuevo</b-button>
						<button :disabled="!$hasPermission('mapping.edit')" type="submit" class=" flex-grow-1 w-100  btn btn-success">Guardar registro</button>
					</div>
				</div>
			</div>

			<hr>
			<h6 class="ml-3">Servicios</h6>
			<div class="mx-4 border rounded my-2 pb-2 u:hover-card" no-body  v-for="(item, index) in model.serviceTypesMapping" :key="index" :class="[(index%2==0?'u:first-card':''),(index==0 && textStatusIndicator!=null?'u:check-card':'')]">
				<!-- <template v-if="item.status != 'deleted'"/> -->
				<div class="sm:scroll-horizontal" v-if="item.status != 'deleted'">
					<div class="d-flex w-100 align-items-end">
						<div class="d-flex flex-grow-1 flex-column px-2">
							<span class="u:text-size-2">Nombre</span>
							<b-form-input
							:disabled="!$hasPermission('mapping.edit')"
							class="w-100 sm:w-input flex-grow-1 form-control"
							size="sm"
							v-model="item.name"
							required />
						</div>
						<div class="d-flex flex-grow-1 flex-column px-2" v-if="_itemMappingName.iata == 'required'">
							<span class="u:text-size-2">Iata</span>
							<b-form-input
							:disabled="!$hasPermission('mapping.edit')"
							class="w-100 sm:w-input flex-grow-1 form-control"
							size="sm"
							v-model="item.iata"
							/>
						</div>
						<div class="d-flex flex-column px-2" v-if="_itemMappingName.minPax == 'required'">
							<span class="u:text-size-2">MinPax</span>
							<b-form-input
							:disabled="!$hasPermission('mapping.edit')"
							style="width:80px"
							class="form-control"
							type="number"
							size="sm"
							v-model="item.minPax"
							v-on:keyup="checkRange(index, 0,1000)"
							required />
						</div>
						<div class="d-flex flex-column px-2" v-if="_itemMappingName.maxPax == 'required'">
							<span class="u:text-size-2">MaxPax</span>
							<b-form-input
							:disabled="!$hasPermission('mapping.edit')"
							style="width:80px"
							class="form-control"
							size="sm"
							type="number"
							v-model="item.maxPax"
							required />
						</div>
						<b-button :disabled="!$hasPermission('mapping.edit')" type="button" size="sm" class="mr-1 mb-1 u:h-fit-content" variant="info" @click="cloneServiceTypesMapping(item)">
							<md-icon icon="library_add" />
						</b-button>
						<b-button :disabled="!$hasPermission('mapping.edit')" type="button" size="sm" class="mr-2 mb-1 u:h-fit-content" variant="danger" @click="()=>{deleteServiceTypesMapping(index)}">
							<md-icon icon="delete" />
						</b-button>
					</div>
					<div class="d-flex w-100 align-items-end" >
						<div class="d-flex flex-grow-1 flex-column px-2">
							<span class="u:text-size-2">Descripcion(Opcional)</span>
							<b-form-input
							:disabled="!$hasPermission('mapping.edit')"
							class="w-100 sm:w-input flex-grow-1 form-control"
							size="sm"
							v-model="item.description"/>
						</div>
						<div class="d-flex flex-grow-1 flex-column px-2">
							<span class="u:text-size-2">Tipo de servicio</span>
							<SelectCustom
								:disabled="!$hasPermission('mapping.edit')"
								v-model="item.serviceTypeId"
								:options ="_serviceTypesOpts"
								trackBy= "value"
								label="text"
								:taggable="false"/>
						</div>
					</div>
				</div>
			</div>

			<b-card class="mx-4 my-2" no-body v-if="model.serviceTypesMapping.length <= 0">
				<div class="d-flex flex-column px-5 py-2 justify-content-center align-items-center"  >
					<h5>Sin servicios registrados</h5>
					<p>Presiona en nuevo para crear un nuevo regsitros</p>
				</div>
			</b-card>


			<div class="text-danger w-100 d-flex justify-content-center text-center" v-if="errorMessage!=null">
				{{errorMessage}}
			</div>

			<div style="height:200px"></div>
		</b-form>
	</b-modal>
</template>

<script>
// import Multiselect from "vue-multiselect";
import SelectCustom from './SelectCustom.vue'
// import SearchSelect from './SearchSelect.vue'
// import Utils from '@/plugins/Utils.js';

const defaultModel = {
	id: null,
	name: "",
	description: "",
	status: "active",
	serviceTypesMapping: [],
};
const defaultItemService = {
	id : null,
	name : "",
	description : "",
	serviceTypeId : null,
	minPax: 1,
	maxPax: 1,
	iata:'',
	status : "active"
}
export default {
	components: {
		// Multiselect,
		SelectCustom,
		// SearchSelect
	},
	props: {
	},
	data() {
		return{
			model: { ...defaultModel },

			textStatusIndicator:null,
			loading:false,
			errorMessage:null,

			arrayMappingName:{},
			selectedMappingName:null,
		}
	},
	computed: {
		_isNewModel(){
			return this.model.id>0? false : true;
		},
		_serviceTypesOpts() {
			return this.$root.auxVars.serviceTypesOpts;
		},
		_serviceTypesMapping(){
			// .slice().reverse()
			return this.model.serviceTypesMapping.filter(item => item.status != 'deleted');
		},
		_itemMappingName(){
			if(Object.keys(this.arrayMappingName).length<=0){
				return null;
			}
			return this.arrayMappingName[this.selectedMappingName];
		}
	},
	created(){
		//cargamos los tipos de servicios
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["serviceTypesOpts"]
		});
	},
	mounted(){
		this.getMappingName();
		console.log("Permiso", (!this.$hasPermission('mapping.edit') || !this._isNewModel));
	},
	methods: {
		onChangeNameMapping(value){
			this.selectedMappingName = value.target.value;
		},
		checkRange(index, min, max){
			if(this.model.serviceTypesMapping[index].minPax<min){
				this.model.serviceTypesMapping[index].minPax=0;
			}
			if(this.model.serviceTypesMapping[index].maxPax > max){
				this.model.serviceTypesMapping[index].minPax=max;
			}
		},
		onSubmit(event){
			event.preventDefault();
			let auxModel = 	JSON.parse(JSON.stringify(this.model));
			if(auxModel.serviceTypesMapping.length<=0){
				this.errorMessage = "Debe agregar al menos un registro de servicio al mapeo";
				return;
			}
			if(auxModel.id == null){
				delete auxModel.id;
				delete auxModel.status;
			}
			auxModel.serviceTypesMapping.forEach(element => {
				if(element.id == null){
					delete element.id;
					delete element.status;
				}

				if(this._itemMappingName.minPax != 'required'){
					element.minPax =  null;
				}
				if(this._itemMappingName.maxPax != 'required'){
					element.maxPax =  null;
				}
				if(this._itemMappingName.iata != 'required'){
					element.iata =  null;
				}
			});
			console.log(auxModel);
			// auxModel.serviceTypesMapping[index].serviceTypeId = selected.value;
			// this.model = auxModel;

			//encendemos la bandera de carga
			this.loading=true;

			let rParams = {
				url: this._isNewModel ?"/mappings": `/mappings/${auxModel.id}` ,
				method: this._isNewModel ? "post" : "put",
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = auxModel;
			}
			this.$root.api
				.request(rParams)
				.then((res) => {
					this.loading=false;
					if(res.status == 200 && res.data.error == false) {
						this.$root.showAlert("Mapeo guardado");
						this.$emit("successCallback");
						this.setModel(res.data.data.id, res.data.data.name);
					}else{
						this.$root.showAlert(res.data.message[0], { variant: "danger" });
					}
					console.log(res);
				})
				.catch(()=>{
					this.loading=false;
					this.$root.handleRequestError;
				});
		},
		activateAnimationStatus(value){
			let me = this;
			me.textStatusIndicator = value;
			setTimeout(()=>{
				me.textStatusIndicator = null;
			}, 3000);
			//desactivamos el mensaje de error
			this.errorMessage=null;
		},
		deleteServiceTypesMapping(newIndex){
			console.log(newIndex);
			// let newIndex=this.model.serviceTypesMapping.length-index-1;
			// console.log(index + " => "+(newIndex));
			//eliminamps un modelo
			if(this.model.serviceTypesMapping[newIndex].id==null){
				this.model.serviceTypesMapping.splice(newIndex, 1)
				return;
			}
			this.model.serviceTypesMapping[newIndex].status = "deleted";
			// this.model.serviceTypesMapping.some(item=>{
			// 	if(Utils.sameObjects(item, itemData)){
			// 		item.status = 'deleted';
			// 		return true;
			// 	}
			// });
		},
		cloneServiceTypesMapping(item){
			this.activateAnimationStatus("Clone");
			//clonamos un modelo existente
			let auxSTM = JSON.parse(JSON.stringify(item));
			auxSTM.id = null;
			auxSTM.status = "active";
			this.model.serviceTypesMapping.unshift({...auxSTM});
		},
		addServiceTypesMapping(){
			console.log(this._itemMappingName);
			if(this._itemMappingName==null){
				this.errorMessage = "Debe seleccionar un nombre para el mapeo";
				return;
			}
			this.activateAnimationStatus("New");
			//agregamos un modelo vacio
			this.model.serviceTypesMapping.unshift({...defaultItemService})
		},
		revertServicesTypesMapping(){
			// this.model.serviceTypesMapping = JSON.parse(JSON.stringify(this.model.serviceTypesMapping.slice().reverse()));
		},
		getMappingName(){
			let rParams = {
				url: `/mappings/apis` ,
				method: "get",
			};
			this.$root.api
				.request(rParams)
				.then((res) => {
					console.log(res);
					this.arrayMappingName = res.data.data;
				})
				.catch(()=>{
					this.$root.handleRequestError;
				});
		},
		newModel(){
			console.log("Reseteamos nuevo modelo");
			this.selectedMappingName = {};
			this.errorMessage ="";
			//reseteamos el modelo a uno nuevo
			this.model=JSON.parse(JSON.stringify(defaultModel));
			this.revertServicesTypesMapping();
		},
		setModel(id, name){
			// recuperamos el modelo para editarlo
			//encendemos la bandera de carga
			this.loading=true;
			//Asiganmos el nombre del modelo para recuperar el indice arrayMappingName
			this.selectedMappingName = name;
			// this.model = JSON.parse(JSON.stringify(data));

			let rParams = {
				url: `/mappings/${id}` ,
				method: "get",
			};
			this.$root.api
				.request(rParams)
				.then((res) => {
					this.loading=false;
					console.log(res);
					this.model = res.data.data;
					this.revertServicesTypesMapping();
				})
				.catch(()=>{
					this.loading=false;
					this.$root.handleRequestError;
				});
		},
		show(){
			console.log("Modal show");
			this.$refs["modal-view"].show();
		},
		close(){
			console.log("Modal close");
			this.$refs["modal-view"].show();
		}
	},
};
</script>
<style>
.u\:h-fit-content{
	height: fit-content;
}
.u\:w-fit-content{
	width: fit-content;
}
/* .multiselect__single{
	text-overflow: ellipsis;
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
} */
.u\:first-card{
	background: #eeeeee;
}
.u\:check-card{
	background: rgb(165, 255, 175)!important;
}
.u\:hover-card:hover{
	background: rgb(170, 199, 252);
}
@media screen and (max-width: 719px) {
	.sm\:scroll-horizontal{
		overflow-y: hidden;
		overflow-x: auto;
		white-space: nowrap;
	}
	.sm\:w-input{
		width: 100px!important;
	}
}
</style>
